import { Form, Formik } from "formik"
import { makeStyles } from "tss-react/mui"
import { MeetingServiceOrder } from "../../../../../modules/merchant/accounting/accounting/accountingTypes"
import { SelectedMainUserState, CreateOrderDialogFlow, CreateOrderDialogType } from "../../createOrderTypes"
import { useDateTime } from "../../../../../modules/localization/useDateTime"
import { MeetingServiceFormContent } from "./MeetingServiceFormContent"
import { mergeValuesWithConfig } from "../form/mergeValuesWithConfig"
import { generateValidationSchema } from "../form/formLib"
import { OrderContextState } from "../../mainForm/helpers"
import { CreateOrderType } from "../../helpers"
import {
    DynamicMainFormValues,
    MeetingServiceConfig,
    MainOrderFormikRef,
    MeetingServiceTabValues,
} from "../form/formTypes"

const useStyles = makeStyles()(() => ({
    form: {
        width: "100%",
    },
}))

type MeetingServiceFormProps = Readonly<{
    user: SelectedMainUserState
    handleClose: () => void
    dialogType: CreateOrderDialogType
    handleOpenSelectPriceListsDialog: () => void
    flowConfig?: CreateOrderDialogFlow
    isDrawerOpen: boolean
    orderType: CreateOrderType
    meetingServiceConfiguration?: MeetingServiceConfig
    orderDetails?: MeetingServiceOrder
    mainValues: DynamicMainFormValues
    orderContext: OrderContextState
    handleSubmitMeetingService: (values: MeetingServiceTabValues) => void
    outerFormik: MainOrderFormikRef
}>

export function MeetingServiceForm({
    user,
    handleClose,
    dialogType,
    handleOpenSelectPriceListsDialog,
    meetingServiceConfiguration,
    flowConfig,
    isDrawerOpen,
    orderType,
    orderDetails,
    mainValues,
    orderContext,
    handleSubmitMeetingService,
    outerFormik,
}: MeetingServiceFormProps) {
    const dateTimeFactory = useDateTime()
    const { classes } = useStyles()

    const validationSchema = generateValidationSchema(dialogType, meetingServiceConfiguration)
    const initialValues = mergeValuesWithConfig({
        existing: mainValues,
        config: meetingServiceConfiguration,
        user,
        dateTimeFactory,
        dialogType,
        orderDetails,
        mode: orderContext.mode,
        flowConfig,
    }) as MeetingServiceTabValues

    return (
        <Formik
            initialValues={initialValues}
            validateOnBlur={false}
            validationSchema={validationSchema}
            onSubmit={handleSubmitMeetingService}
            enableReinitialize
        >
            <Form className={classes.form}>
                <MeetingServiceFormContent
                    user={user}
                    handleClose={handleClose}
                    dialogType={dialogType}
                    handleOpenSelectPriceListsDialog={handleOpenSelectPriceListsDialog}
                    meetingServiceConfiguration={meetingServiceConfiguration}
                    flowConfig={flowConfig}
                    isDrawerOpen={isDrawerOpen}
                    orderType={orderType}
                    outerFormik={outerFormik}
                    mode={orderContext.mode}
                />
            </Form>
        </Formik>
    )
}
